const timer = (time, selector) => {

    function getTimeRemaining(){
        const t = Date.parse(time) - Date.parse(new Date()),
            seconds = Math.floor((t/1000) % 60),
            minutes = Math.floor((t/1000/60) % 60),
            hours = Math.floor((t/1000/60/60) % 24),
            days = Math.floor(t / (1000*60*60*24));

        return {
            'total': t,
            'seconds': seconds,
            'minutes': minutes,
            'hours': hours,
            'days': days
        }
    }

    function getZero(num){
        if (num >= 0 && num <= 10){
            return '0' + num;
        } else {
            return num;
        }
    }

    function setClock() {
        const timerSelector = document.querySelector(selector),
            days = timerSelector.querySelector("#days"),
            hours = timerSelector.querySelector("#hours"),
            minutes = timerSelector.querySelector("#minutes"),
            seconds = timerSelector.querySelector("#seconds"),
            timeInterval = setInterval(updateClock, 1000);

        updateClock();

        function updateClock(){
            const t = getTimeRemaining();

            days.innerHTML = getZero(t.days);
            hours.innerHTML = getZero(t.hours);
            minutes.innerHTML = getZero(t.minutes);
            seconds.innerHTML = getZero(t.seconds);

            if (t.total <= 0){
                clearInterval(timeInterval);
            }
        }
    }

    setClock();
}
export default timer;